import { render, staticRenderFns } from "./TrackingScanItem.vue?vue&type=template&id=2cf788d6&scoped=true"
import script from "./TrackingScanItem.vue?vue&type=script&lang=ts"
export * from "./TrackingScanItem.vue?vue&type=script&lang=ts"
import style0 from "./TrackingScanItem.vue?vue&type=style&index=0&id=2cf788d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf788d6",
  null
  
)

export default component.exports